import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import DetectedEmails from "@/pages/DetectedEmails";
import GmailInbox from "@/pages/GmailInbox";
import TasksPage from "@/pages/TasksPage";
import CalendarPage from "@/pages/CalendarPage";
import ChildrenPage from "@/pages/ChildrenPage";
import ChildProfilePage from "@/pages/ChildProfilePage";
import SearchPage from "@/pages/SearchPage";
import FamilyStoryPage from "@/pages/FamilyStoryPage";
import YearbookPage from "@/pages/YearbookPage";
import LegacyPage from "@/pages/LegacyPage";
import ChildJourneyPage from "@/pages/ChildJourneyPage";
import FounderDashboard from "@/pages/FounderDashboard";
import CopilotPage from "@/pages/CopilotPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import AdminReadinessPage from "@/pages/AdminReadinessPage";
import BriefingPage from "@/pages/BriefingPage";
import MemoriesPage from "@/pages/MemoriesPage";
import SettingsPage from "@/pages/SettingsPage";
import BillingPage from "@/pages/BillingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PaywallPage from "@/pages/PaywallPage";
import ConnectGmailPage from "@/pages/ConnectGmailPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render handles the OAuth return without race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="gmail" element={<GmailInbox />} />
        <Route path="detected" element={<DetectedEmails />} />
        <Route path="children" element={<ChildrenPage />} />
        <Route path="children/:childId" element={<ChildProfilePage />} />
        <Route path="children/:childId/journey" element={<ChildJourneyPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="family-story" element={<FamilyStoryPage />} />
        <Route path="yearbook" element={<YearbookPage />} />
        <Route path="legacy" element={<LegacyPage />} />
        <Route path="admin/founder" element={<FounderDashboard />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="copilot" element={<CopilotPage />} />
        <Route path="briefing" element={<BriefingPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/billing" element={<BillingPage />} />
        <Route path="upgrade" element={<PaywallPage />} />
        <Route path="connect-gmail" element={<ConnectGmailPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="memories" element={<MemoriesPage />} />
        <Route path="readiness" element={<AdminReadinessPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#16271F",
              color: "#fff",
              border: "1px solid #1F3D32",
              borderRadius: "14px",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
